import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { FaTerminal, FaUserShield, FaUsers, FaTools, FaSignOutAlt } from "react-icons/fa";

export default function SuperAdminLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/super-admin/login");
  };

  const linkStyle = ({ isActive }) => ({
    display: "flex",
    alignItems: "center",
    padding: "14px 18px",
    borderRadius: "12px",
    textDecoration: "none",
    marginBottom: "8px",
    background: isActive ? "rgba(0, 242, 255, 0.08)" : "transparent",
    borderLeft: isActive ? "3px solid #00f2ff" : "3px solid transparent",
    color: isActive ? "#00f2ff" : "#94a3b8",
    fontWeight: "700",
    fontSize: "12px",
    gap: "12px"
  });

  return (
    <div style={{ display: "flex", background: "#020617", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      {/* Sidebar */}
      <div style={{ width: "260px", background: "#020617", borderRight: "1px solid rgba(255,255,255,0.05)", display: "flex", flexDirection: "column", padding: "20px" }}>
        <h2 style={{ color: "#fff", fontSize: "18px", fontWeight: "900", letterSpacing: "1px", marginBottom: "30px" }}>
          ROOT<span style={{ color: "#00f2ff" }}>PANEL</span>
        </h2>
        
        <nav style={{ flex: 1 }}>
          <NavLink to="/super-admin" style={linkStyle} end>
            <FaTerminal size={16} /> COMMAND CENTER
          </NavLink>
          <NavLink to="/super-admin/create-admin" style={linkStyle}>
            <FaUserShield size={16} /> DEPLOY STAFF
          </NavLink>
          <NavLink to="/super-admin/users" style={linkStyle}>
            <FaUsers size={16} /> USER MANAGEMENT
          </NavLink>
          <NavLink to="/super-admin/maintenance" style={linkStyle}>
            <FaTools size={16} /> MAINTENANCE
          </NavLink>
        </nav>

        <button onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px", background: "rgba(239, 68, 68, 0.05)", border: "1px solid rgba(239, 68, 68, 0.1)", color: "#ef4444", borderRadius: "10px", fontWeight: "800", cursor: "pointer", fontSize: "11px" }}>
          <FaSignOutAlt /> LOGOUT SESSION
        </button>
      </div>

      {/* Main Content Area */}
      <div style={{ flex: 1, padding: "40px", overflowY: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}